<template>
    <div class="e6-select-remote">
        <el-select
                v-model="myValue"
                clearable
                filterable
                remote
                :remote-method="remoteMethod"
                :loading="loading"
        >
            <el-option v-for="item in remoteData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
    </div>
</template>

<script>
    import request from "_private/utils/request";

    export default {
        name: "E6SelectRemote",
        props: {
            remoteApi: {
                type: Object,
                default: function () {
                    return {
                        url: "",
                        method: "",
                        key: ""
                    };
                }
            },
            value: {
                default: ""
            }
        },
        data() {
            return {
                remoteData: [],
                loading: false,
                apiConfig: {},
                myValue: ""
            };
        },
        watch: {
            myValue(val) {
                this.$emit("update:value", val);
            }
        },
        created() {
            if (!this.remoteApi.url) {
                throw "url is empty!";
            }
            if (!this.remoteApi.method) {
                throw "method is empty!";
            }
            this.FetchData(this.remoteApi);
            this.myValue = this.value;
        },
        methods: {
            FetchData(remoteApi) {
                this.apiConfig = {
                    url: remoteApi.url,
                    method: remoteApi.method
                };
            },
            remoteMethod(query) {
                this.loading = true;
                if (query !== "") {
                    if (this.apiConfig.method === "get") {
                        this.apiConfig.params = {};
                        this.apiConfig.params[this.remoteApi.key] = query;
                    } else if (this.apiConfig.method === "post") {
                        this.apiConfig.data = {};
                        this.apiConfig.data[this.remoteApi.key] = query;
                    }
                    return request(this.apiConfig)
                        .then(response => {
                            this.loading = false;
                            this.remoteData = response.result;
                        })
                        .catch(error => {
                            this.loading = false;
                            console.log(error);
                        });
                } else {
                    this.remoteData = [];
                }
            }
        }
    };
</script>
